export const getDateTIme = (dateString: string | number) => {
    if (!dateString) {
        return '';
    }

    return `${(new Date(dateString)).toLocaleTimeString()} ${(new Date(dateString)).toLocaleDateString()}`
}